import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { trackPageview } from '../lib/api';
import { useLang } from '../context/LanguageContext';

export default function Layout() {
  const location = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    // Skip tracking admin routes
    if (location.pathname.startsWith('/admin')) return;
    trackPageview(location.pathname, lang);
  }, [location.pathname, lang]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-black">
      <Header />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
